export const getImagePath = (image?: string | File | null) => {
  if (!image) return undefined

  if (typeof image === 'string') {
    return image
  }

  return URL.createObjectURL(image)
}
